import { isStringNullOrEmpty } from "../../utils/string.js";
import "moment-timezone";
import { isNullOrUndefined } from "../../utils/object.js";
import "react-intl";
function mapViewFilterToString(filter, possibleKeys) {
  const searchParams = new URLSearchParams();
  possibleKeys?.forEach((key) => {
    const value = filter?.[key];
    if (!isNullOrUndefined(value)) {
      searchParams.set(key, JSON.stringify(value));
    }
  });
  return searchParams.toString();
}
function getNonEmptyValueValidator(...keys) {
  return (filter) => keys?.map((key) => !isStringNullOrEmpty(filter?.find((f) => f.key === key)?.value))?.every((v) => v);
}
function mapSortingToFilter(sorting) {
  return [
    { key: "sortField", value: sorting?.field },
    { key: "sortOrder", value: sorting?.sort }
  ];
}
export {
  getNonEmptyValueValidator,
  mapSortingToFilter,
  mapViewFilterToString
};
//# sourceMappingURL=utils.js.map
